import { Button } from "@chef/components";

import {
  openModal,
  selectIsEditModeOnForWeek,
  toggleEditModeForWeek,
} from "@chef/state-management";
import {
  useAppDispatch,
  useAppSelector,
  useExtendedBasketData,
} from "@chef/state-management/hooks";
import { intl } from "./EditModeButton.Intl";

type EditModeButtonProps = {
  week: number;
  year: number;
  revertOnly?: boolean;
};

export const EditModeButton = ({
  week,
  year,
  revertOnly = false,
}: EditModeButtonProps) => {
  const dispatch = useAppDispatch();

  const { data: extendedBasketData } = useExtendedBasketData({ week, year });

  const isEditModeOnForWeek = useAppSelector(
    selectIsEditModeOnForWeek({ week, year }),
  );

  const isBasketChanged = extendedBasketData.basketHasDeviations;

  const handleClick = () => {
    const shouldRevert = isEditModeOnForWeek && isBasketChanged;

    if (shouldRevert || revertOnly) {
      dispatch(openModal({ id: "CONFIRM_REVERT", week, year }));
    } else {
      dispatch(toggleEditModeForWeek({ week, year }));
    }
  };

  const buttonLabel =
    revertOnly || isEditModeOnForWeek
      ? intl.DISCARD_CHANGES
      : intl.CHANGE_DISHES;

  return (
    <Button
      primary={!isEditModeOnForWeek && !revertOnly}
      outlined={isEditModeOnForWeek || revertOnly}
      onClick={handleClick}
      className="mt-2 mb-4 md:mt-0"
    >
      {buttonLabel}
    </Button>
  );
};
